module.exports = __webpack_public_path__ + "img/ToyFaces_Colored_BG_1.d76d04c1.jpg";